var map = {
	"./algeria-logo-icon.webp": "e7c5",
	"./america-logo-icon.webp": "8078",
	"./argentina-logo-icon.webp": "1f11",
	"./australia-logo-icon.webp": "8f6a",
	"./austria-logo-icon.webp": "966c",
	"./belgium-logo-icon.webp": "9885",
	"./bosnia-herzegovina-logo-icon.webp": "b52a",
	"./brasil-logo-icon.webp": "3653",
	"./canada-logo-icon.webp": "9b5d",
	"./capeverde-logo-icon.webp": "10cd",
	"./columbia-logo-icon.webp": "48b7",
	"./congo-dr-logo-icon.webp": "818a",
	"./croatia-logo-icon.webp": "b87d",
	"./curacao-logo-icon.webp": "2d57",
	"./czechia-logo-icon.webp": "1564",
	"./ecuador-logo-icon.webp": "b988",
	"./egypt-logo-icon.webp": "35ed",
	"./england-logo-icon.webp": "0ff5",
	"./france-logo-icon.webp": "7b9b",
	"./germany-logo-icon.webp": "527e",
	"./ghana-logo-icon.webp": "7a4e",
	"./haiti-logo-icon.webp": "f7fb",
	"./iran-logo-icon.webp": "c52f",
	"./iraq-logo-icon.webp": "a9d6",
	"./ivorycoast-logo-icon.webp": "9178",
	"./japan-logo-icon.webp": "24f3",
	"./jordan-logo-icon.webp": "fa92",
	"./mexico-logo-icon.webp": "6627",
	"./morroco-logo-icon.webp": "7bba",
	"./netherlands-logo-icon.webp": "cd38",
	"./newzealnd-logo-icon.webp": "b3be",
	"./nigeria-logo-icon.webp": "17b5",
	"./norway-logo-icon.webp": "be7e",
	"./panama-logo-icon.webp": "53c2",
	"./paraaguay-logo-icon.webp": "580c",
	"./portugal-logo-icon.webp": "b4ee",
	"./qatar-logo-icon.webp": "1287",
	"./saudiarabia-logo-icon.webp": "827d",
	"./scotland-logo-icon.webp": "a392",
	"./senegal-logo-icon.webp": "9417",
	"./southafrica-logo-icon.webp": "c045",
	"./southkorea-logo-icon.webp": "3e2f",
	"./spain-logo-icon.webp": "2978",
	"./sweden-logo-icon.webp": "e8ed",
	"./swittzerland-logo-icon.webp": "fc1b",
	"./tunisia-logo-icon.webp": "8eb4",
	"./turkiye-logo-icon.webp": "dcfa",
	"./uruguay-logo-icon.webp": "093e",
	"./uzberistan-logo-icon.webp": "0df9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "29c0";